module.exports = __webpack_public_path__ + "img/map_pin.e974c151.png";